(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nov-header-5"]) return;
  try {
    
  if (window.innerWidth > 1199) {
    const siteNavBtns = document.querySelectorAll('.site-nav--btn');
    const mobileMenu = document.getElementById('mobile_menu');
    const sidebarOverlay = document.querySelector('.sidebar-overlay');

    siteNavBtns.forEach(function(btn) {
      btn.removeEventListener('click', handleClick);
      btn.addEventListener('click', handleClick);
    });

    function handleClick(event) {
      const btn = event.currentTarget;
      if (btn.classList.contains('act')) {
        btn.classList.remove('act');
        sidebarOverlay.classList.remove('act');
        mobileMenu.classList.remove('act');
      } else {
        btn.classList.add('act');
        sidebarOverlay.classList.add('act');
        mobileMenu.classList.add('act');
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
